import { Box, styled } from '@mui/material';
import { forwardRef, ReactNode } from 'react';

interface WorkflowTabPanelProps {
  children: ReactNode;
  value: number;
  index: number;
}

const PREFIX = 'WorkflowTabPanel';

const classes = {
  tabPanelHidden: `${PREFIX}-container`,
  tabPanelVisible: `${PREFIX}-header`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`& .${classes.tabPanelHidden}`]: {
    visibility: 'hidden',
  },
  [`& .${classes.tabPanelVisible}`]: {
    visibility: 'visible',
  },
}));

// Custom tab panel to always render children even if not focused. This is necessary
// because we allow the user to save the workflow form even when its not in focus.
const WorkflowTabPanel = forwardRef<HTMLDivElement, WorkflowTabPanelProps>(
  ({ children, value, index, ...props }, ref) => {
    return (
      <StyledBox
        component="div"
        ref={ref}
        role="tabpanel"
        hidden={value !== index}
        className={
          value === index ? classes.tabPanelVisible : classes.tabPanelHidden
        }
        {...props}>
        {children}
      </StyledBox>
    );
  },
);

export default WorkflowTabPanel;
